var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7999 0.800049H3.1999C2.98773 0.800049 2.78425 0.884334 2.63422 1.03436C2.48419 1.18439 2.3999 1.38788 2.3999 1.60005V14.4C2.3999 14.6122 2.48419 14.8157 2.63422 14.9657C2.78425 15.1158 2.98773 15.2 3.1999 15.2H12.7999C13.0121 15.2 13.2156 15.1158 13.3656 14.9657C13.5156 14.8157 13.5999 14.6122 13.5999 14.4V1.60005C13.5999 1.38788 13.5156 1.18439 13.3656 1.03436C13.2156 0.884334 13.0121 0.800049 12.7999 0.800049ZM10.3999 12H5.5999V10.4H10.3999V12ZM10.3999 8.80005H5.5999V7.20005H10.3999V8.80005ZM10.3999 5.60005H5.5999V4.00005H10.3999V5.60005Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanChange);
export default __webpack_public_path__ + "static/media/PlanChange.edcd8540dd4fe2dea0530882760c3344.svg";
export { ForwardRef as ReactComponent };